export default __webpack_public_path__ + "static/media/ip-car-thumbnail.b97c1f25.jpg";